module.exports = __webpack_public_path__ + "static/media/red-x.dca5d4a0.svg";